import './index.scss';

import { Component, ReactNode } from 'react';

import t from 'utils/i18n';
import { BraxButton } from '../BraxButton';

export type BraxNotificationProps = ({
    type: 'project',
    project: {
        thumbnail: string,
        name: string
    }
} | {
    type: 'coupon',
    coupon: {
        name: string,
        expiration: Date
    }
}) & {
    date: Date,
    description: string,
    children: ReactNode
};

export type BraxNotificationState = {
    couponExpiration: {
        expired: boolean,
        hours: number,
        minutes: number
    }
};

export class BraxNotification extends Component<BraxNotificationProps, BraxNotificationState> {

    state = {
        couponExpiration: {
            expired: false,
            hours: 0,
            minutes: 0
        }
    };

    readonly today = new Date();

    componentDidUpdate() {
        this.updateCoupon();
    }

    updateCoupon() {
        if (this.props.type === 'project')
            return;

        const time = Math.ceil(this.props.coupon.expiration.getTime() - this.today.getTime());

        const hours = Math.abs(time) / (1000 * 60 * 60);

        this.setState({
            couponExpiration: {
                expired: time <= 0,
                hours: hours,
                minutes: hours / 60
            }
        });
    }

    getThumbnail() {
        return this.props.type === 'coupon' ? (
            <div className="coupon">
                <p>{ this.props.coupon.name }</p>

                <span>
                    { this.state.couponExpiration.expired ? (
                        t('Expirado a %n horas', Math.min(this.state.couponExpiration.hours, 1))
                    ) : (
                        t('Restam %n horas e %n minutos', Math.min(this.state.couponExpiration.hours, 1), Math.min(this.state.couponExpiration.minutes, 1))
                    ) }
                </span>
            </div>
        ) : (
            <img src={this.props.project.thumbnail} className="thumbnail" />
        );
    }

    getTargetDay() {
        const difference = Math.ceil(
            (this.props.date.getTime() - this.today.getTime()) / (1000 * 60 * 60 * 24)
        );

        switch (difference) {
            case -2:
                return 'Anteontem';

            case -1:
                return 'Ontem';

            case 0:
                return 'Hoje';

            case 1:
                return 'Amanhã';

            case 2:
                return 'Depois de amanhã';

            default:
                return `${this.props.date.getDate()}/${this.props.date.getMonth() + 1}`;
                // return `${this.date.getDate()}/${this.date.getMonth() + 1} ${this.date.getHours()}:${this.date.getMinutes()}`;
        }
    }

    getDate() {
        return (
            <p className="date">
                <span /> { this.props.date.getHours() }:{ this.props.date.getMinutes() } { t(this.getTargetDay()) }
            </p>
        )
    }

    getDescription() {}

    render() {
        return (
            <div className="brax-notification">
                { this.props.children }

                <BraxButton variant="secondary">{ t('Limpar notificação') }</BraxButton>
            </div>
        );
    }

}
